const PROJECT_DETAIL = /^\/projects\/([^/?#]+)(?:\/([^/?#]+))?$/;
const ID_VAR = /(^|_)id$/;

function isNavigablePrefix(prefix, findMatchingPage) {
  const matched = findMatchingPage(prefix);
  if (!matched) {
    return false;
  }
  return Object.entries(matched.urlVars || {}).every(([name, value]) => !ID_VAR.test(name) || /^\d+$/.test(String(value)));
}

export function crumbSegments(currentPath, findMatchingPage) {
  const p = (currentPath || "").replace(/\/+$/, "");
  const projectDetail = p.match(PROJECT_DETAIL);
  if (projectDetail && projectDetail[1] !== "new") {
    const id = projectDetail[1];
    const tab = projectDetail[2] || null;
    const segs = [
      { label: "projects", href: "/projects" },
      { label: id, href: `/projects/${id}` },
    ];
    if (tab) {
      segs.push({ label: tab, href: `/projects/${id}/${tab}` });
    }
    return segs;
  }
  if (p === "/projects/new") {
    return [
      { label: "projects", href: "/projects" },
      { label: "new", href: "/projects/new" },
    ];
  }
  if (p === "" || p === "/projects" || p === "/board") {
    return [];
  }
  const parts = p.split("/").filter(Boolean);
  const segs = [];
  let acc = "";
  parts.forEach((part, idx) => {
    acc += `/${part}`;
    const isCurrent = idx === parts.length - 1;
    segs.push({ label: part, href: isCurrent || isNavigablePrefix(acc, findMatchingPage) ? acc : null });
  });
  return segs;
}
